<template>
    <h5>{{ text }}</h5>
</template>

<script>

export default {
  name: 'PageTitle',
  props: {
    text: {
      required: true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/reportItems/PageTitle.vue